import { RootState, UserProfileState } from "../../../../store"

interface MapStateToProps {
  userProfiles: UserProfileState
}

export const mapStateToProps = (state: RootState): MapStateToProps => ({
  userProfiles: state.userProfiles,
})
